import React, { memo } from 'react';
import { IconButton, TextField } from '@mui/material';
import { DesktopDatePicker as MuiDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ControlledError from '../ControlledError';

import { ReactComponent as CalendarIcon } from '../../../../assets/icons/Calendar.svg';
import { ReactComponent as ArrowRight } from '../../../../assets/icons/ArrowRight.svg';
import { ReactComponent as ArrowDown } from '../../../../assets/icons/ArrowDown.svg';

import { useStyles } from './styles';
import { useStyles as textfieldStyles } from '../TextField/styles';
import moment from 'moment';

interface IDatePickerProps {
  value: any;
  minDate?: any;
  maxDate?: any;
  error?: string;
  inputLabel?: string;
  required?: boolean;
  disabled?: boolean;
  skippable?: boolean;
  inputClassName?: string;
  defaultCalendarMonth?: any;
  testId?: string;
  onChange: (value: any, inputValue?: string) => void;
  onBlur?: (e?: any) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLElement>) => void;
}

const DatePicker = ({
  value,
  minDate,
  maxDate,
  error,
  inputLabel,
  required,
  disabled,
  skippable = false,
  inputClassName,
  defaultCalendarMonth,
  testId,
  onChange,
  onKeyDown,
}: // onBlur,
IDatePickerProps) => {
  const classes = useStyles();
  const textFieldClasses = textfieldStyles();
  return (
    <ControlledError show={!!error} error={error}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <MuiDatePicker
          // label={inputLabel}
          inputFormat="MM/DD/YYYY"
          views={['year', 'month', 'day']}
          value={value}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          defaultCalendarMonth={defaultCalendarMonth}
          components={{
            OpenPickerIcon: CalendarIcon,
            LeftArrowIcon: (props = {}) => <ArrowRight {...props} className={classes.leftArrowIcon} />,
            RightArrowIcon: (props = {}) => <ArrowRight {...props} className={classes.rightArrowIcon} />,
            SwitchViewButton: (props = {}) => {
              return (
                <IconButton size="small" {...props}>
                  <ArrowDown
                    className={`${classes.switchViewIcon} ${
                      props?.children?.props?.ownerState?.openView === 'year' ? classes.switchViewIconRotated : ''
                    }`}
                  />
                </IconButton>
              );
            },
          }}
          PopperProps={{
            className: classes.datePicker,
            style: { zIndex: 9999 },
            popperOptions: {
              strategy: 'fixed',
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: 'viewport',
                  },
                },
                {
                  name: 'flip',
                  options: {
                    fallbackPlacements: ['top', 'bottom'],
                  },
                },
              ],
            },
          }}
          onChange={onChange}
          renderInput={params => (
            <TextField
              {...params}
              data-testid={testId}
              error={!!error}
              label={
                <>
                  <span>{inputLabel}</span>
                  {(required || skippable) && (
                    <span className={required ? textFieldClasses.requiredMark : textFieldClasses.skippableMark}>
                      {required ? '*' : '**'}
                    </span>
                  )}
                </>
              }
              className={`${textFieldClasses.input} ${inputClassName || ''}`}
              onKeyDown={onKeyDown}
            />
          )}
        />
      </LocalizationProvider>
    </ControlledError>
  );
};

export default memo(DatePicker);
